import React, { FC } from "react";

import { formatUpliftCI } from "@intelligems/ig-graphs/impact-calculations";
import { IgAnalyticsTooltip } from "@intelligems/ig-theme/IgAnalyticsTooltip";
import {
  IgTypography,
  IgTypographyProps,
} from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useConfiguration } from "@src/api/configurations/use-configuration";

interface UpliftPlusMinusProps {
  customFormatterOptions?: Intl.NumberFormatOptions;
  typographyProps?: IgTypographyProps;
  upliftWrapper: {
    upliftCiHigh: number | null | undefined;
    upliftCiLow: number | null | undefined;
  };
}

export const UpliftPlusMinus = ({
  upliftWrapper,
  typographyProps,
}: UpliftPlusMinusProps) => {
  const theme = useTheme();
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  return (
    <Grid>
      <IgAnalyticsTooltip
        leaveDelay={300}
        title={
          upliftWrapper?.upliftCiHigh && upliftWrapper?.upliftCiLow ? (
            <IgTypography>95% confidence interval</IgTypography>
          ) : (
            ""
          )
        }
      >
        {upliftWrapper?.upliftCiHigh && upliftWrapper?.upliftCiLow ? (
          <IgTypography
            {...typographyProps}
            sx={{
              color: theme.palette.text.secondary,
              ...typographyProps?.sx,
            }}
          >
            {formatUpliftCI(
              upliftWrapper.upliftCiLow,
              storeCurrencyConfig?.value?.locale
            )}{" "}
            to{" "}
            {formatUpliftCI(
              upliftWrapper.upliftCiHigh,
              storeCurrencyConfig?.value?.locale
            )}
          </IgTypography>
        ) : (
          <IgTypography></IgTypography>
        )}
      </IgAnalyticsTooltip>
    </Grid>
  );
};
